import { useState } from 'react';
import { Alert, Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button/Button';

// Shown after a bulk delete that removed only some of the files: the
// rest stay in the list and can be deleted again.
const DeleteFilesResultBanner = ({
  notDeletedNames,
  requestedCount,
  onClose,
}: {
  notDeletedNames: string[];
  requestedCount: number;
  onClose: () => void;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Alert severity="warning" onClose={onClose}>
      <FormattedMessage
        id="filesNotDeleted"
        defaultMessage="{notDeleted} of {total} files were not deleted."
        values={{
          notDeleted: notDeletedNames.length,
          total: requestedCount,
        }}
      />
      <ToggleButton
        variant="text"
        customVariant="text-small"
        onClick={() => setExpanded((value) => !value)}
        aria-expanded={expanded}
        aria-label="Toggle files not deleted"
      >
        {expanded ? (
          <FormattedMessage
            id="hideFiles"
            defaultMessage="Hide files"
          />
        ) : (
          <FormattedMessage
            id="showFiles"
            defaultMessage="Show files"
          />
        )}
      </ToggleButton>
      <Collapse in={expanded}>
        <NamesList aria-label="Files not deleted">
          {notDeletedNames.map((name, index) => (
            <li key={`${name}-${index}`}>{name}</li>
          ))}
        </NamesList>
      </Collapse>
    </Alert>
  );
};

const ToggleButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

const NamesList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(1, 0, 0),
  paddingLeft: theme.spacing(2.5),
  maxHeight: 160,
  overflowY: 'auto',
  wordBreak: 'break-all',
}));

export default DeleteFilesResultBanner;
